import { INVALID_PROFILENAME_OR_PASSWORD, INVALID_PASSWORD, INVALID_PROFILENAME, INVALID_SHORTCODE, INVALID_HWID } from "../networking/networking";
import { globalAny } from "../utils/Utils";

export const mapErrorMessage = () => [
	{ errorCode: INVALID_PROFILENAME_OR_PASSWORD, errorMessage: globalAny.language.toast_invalid_credential },
	{ errorCode: INVALID_PASSWORD, errorMessage: globalAny.language.toast_invalid_credential },
	{ errorCode: INVALID_PROFILENAME, errorMessage: globalAny.language.toast_invalid_credential },
	{ errorCode: INVALID_SHORTCODE, errorMessage: globalAny.language.invalid_shortcode },
	{ errorCode: INVALID_HWID, errorMessage: globalAny.language.hwid_error },
];
